import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface holidayState {
	isLoading: boolean;
	holidayList: any;
	totalHoliday: number;
	holidayDetail: any;
}

const initialState: holidayState = {
	isLoading: false,
	holidayList: [],
	totalHoliday: 0,
	holidayDetail: {}
};

const holidaySlice = createSlice({
	name: 'holidaySlice',
	initialState,
	reducers: {
		getAllHolidayInIt: state => {
			state.isLoading = true;
		},
		getAllHolidaySuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalHoliday = data.count;
			state.holidayList = [...data.holidays];
		},
		getAllHolidayError: state => {
			state.isLoading = false;
			state.holidayList = [];
			state.totalHoliday = 0;
		},
		deleteholidayInit: state => {
			state.isLoading = true;
		},
		deleteholidaySuccess: state => {
			// state.isLoading = false;
		},
		deleteholidayError: state => {
			state.isLoading = false;
		},
		addHolidayInIt: state => {
			state.isLoading = true;
		},
		addHolidaySuccess: state => {
			state.isLoading = false;
		},
		addHolidayError: state => {
			state.isLoading = false;
		},
		getHolidayByIdInIt: state => {
			state.isLoading = true;
		},
		getHolidayByIdSuccess: (state, action: PayloadAction<any>) => {
			// console.log(action.payload.data.governmentHolidays);

			state.isLoading = false;
			state.holidayDetail = { ...action.payload.data.governmentHolidays };
		},
		getHolidayByIdError: state => {
			state.isLoading = false;
		},
		clearHolidayDetail: state => {
			state.holidayDetail = {};
		},
		
	}
});

export const {
	getAllHolidayError,
	getAllHolidayInIt,
	getAllHolidaySuccess,
	deleteholidayError,
	deleteholidayInit,
	deleteholidaySuccess,
	addHolidayError,
	addHolidayInIt,
	addHolidaySuccess,
	getHolidayByIdError,
	getHolidayByIdInIt,
	getHolidayByIdSuccess,
	clearHolidayDetail
} = holidaySlice.actions;
export default holidaySlice.reducer;
